import config from '../../../config'
import http from './http-util'

class MerchantOrderServiceApi {
  static sendOrder = requestBody => token =>
    http.post(
      token,
      `${config.merchantOrderServiceUrl}/orders`,
      JSON.stringify(requestBody),
    )
}

export default MerchantOrderServiceApi
